<template>
    <div class="dialog-title pl-5">
        <span class="caption"> 
            <span>{{ [undefined, null, ""].includes(title)? defaultTitle : title }}</span>
            <span v-if="![undefined, null, ''].includes(subTitle)"> > {{ subTitle }}</span>
        </span>
        <span class="button square closer" @click="closeDialog"></span>
    </div>
</template>

<script>
export default {
    name: "DialogTitle",
    props: {
        title: String,
        defaultTitle: String,
        subTitle: String
    },
    methods:{
        closeDialog(){
            //Mettere sulla dichiarazione del componente @closeDialog="FUNZIONE_PER_CHIUDERE_QUESTA_DIALOG"
            this.$emit('closeDialog');
        }
    }
    
}
</script>